import { type Role, type RoleName } from '~/gql/graphql'
import { type TranslationSchema } from '~/locales/resources'

export const userRole: RoleName[] = [
  'MFORCE',
  'MFORCE_WITH_SETTING',
  'PARTNER_MANAGER',
  'PARTNER_MANAGER_WITH_SETTING',
  'PARTNER',
  'PARTNER_WITH_SETTING',
  'USER_MANAGER',
  'USER_MANAGER_WITH_SETTING',
  'USER',
  'USER_WITH_SETTING',
]

export const userRoleNameToLabel: Record<RoleName, keyof TranslationSchema> = {
  MFORCE: 'M-Force',
  MFORCE_WITH_SETTING: 'M-Force',
  PARTNER_MANAGER: 'partner_administrator',
  PARTNER_MANAGER_WITH_SETTING: 'partner_administrator',
  PARTNER: 'partner',
  PARTNER_WITH_SETTING: 'partner',
  USER_MANAGER: 'user_administrator',
  USER_MANAGER_WITH_SETTING: 'user_administrator',
  USER: 'user',
  USER_WITH_SETTING: 'user',
}

// 設定アクセス権の有無（*_WITH_SETTING）はタクソノミ設計で区別していないため、同じイベント名に寄せる。
export const userRoleNameToLogEventName = {
  MFORCE: 'Add M-Force user',
  MFORCE_WITH_SETTING: 'Add M-Force user',
  PARTNER_MANAGER: 'Add partner user',
  PARTNER_MANAGER_WITH_SETTING: 'Add partner user',
  PARTNER: 'Add partner user',
  PARTNER_WITH_SETTING: 'Add partner user',
  USER_MANAGER: 'Add client user',
  USER_MANAGER_WITH_SETTING: 'Add client user',
  USER: 'Add client user',
  USER_WITH_SETTING: 'Add client user',
} as const satisfies Record<RoleName, string>

export const userRoleNameToRoleId: Record<RoleName, Role['id']> = {
  MFORCE: 1,
  MFORCE_WITH_SETTING: 6,
  PARTNER_MANAGER: 2,
  PARTNER_MANAGER_WITH_SETTING: 7,
  PARTNER: 3,
  PARTNER_WITH_SETTING: 8,
  USER_MANAGER: 4,
  USER_MANAGER_WITH_SETTING: 9,
  USER: 5,
  USER_WITH_SETTING: 10,
}
